// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__2zG_U","path":"Breadcrumb_path__3-MPu"};